<template>
    <div v-if="isValid" class="w-100 mt-5">
        <my-form v-if="!isAdmin" ref="form">
            <v-row wrap>
                <v-col cols="12" v-if="!payments || (payments && payments.length == 0)">
                    <p class="ma-0 fw-400 fs-18">
                        {{selectedWebsite ? 'Integrate Stripe account to receive money from selling' : 'Create website to connect Stripe'}}
                    </p>
                </v-col>
                <v-col cols="4" style="position: relative" v-else>
                    <div class="pa-5 stripe-container d-flex flex-column align-center justify-center" >
                        <div class="d-flex flex-row align-center justify-start w-100">
                            <v-img max-width="100px" max-height="50px" contain :src="$root.getSrc('default/drop_icons/stripe.png')" alt="Drop" />
                            <p class="ml-4 ma-0 fw-600 fs-18 drop-blue">
                                Stripe {{payments[0].is_valid ? 'successfully' : ''}} connected
                            </p>
                        </div>
                        <div class="mt-1 d-flex justify-center flex-column">
                            <p v-if="!payments[0].is_valid" style="color: red;" class="ml-4 ma-0 fw-600 fs-14 drop-blue">
                                To receive payments you have to connect bank details in Your Stripe dashboard
                            </p>
                            <primary-button class="mt-3" v-if="!payments[0].is_valid" @clickBtn="refreshStripe()" :loading="load" :activeButton="true">Refresh stripe data</primary-button>
                        </div>
                    </div>

                    <div @click="disconnect" class="delete-icon hover">
                        <v-img max-height="24px" max-width="24px" contain :src="$root.getSrc('default/drop_icons/remove_icon.svg')"></v-img>
                    </div>
                </v-col>
                <v-col cols="4" v-if="!payments || (payments && payments.length == 0 && !is_error)">
                    <div class="w-100 d-flex justify-center" v-if="load">
                        <v-progress-circular :size="100" color="primary" indeterminate></v-progress-circular>
                    </div>
                    <div v-if="onboardLink && !load" @click="goToHref" class="pa-5 hover stripe-container d-flex flex-row align-center justify-center" >
                        <v-img max-width="100px" max-height="50px" contain :src="$root.getSrc('default/drop_icons/stripe.png')" alt="Drop" />
                        <p class="ml-4 ma-0 fw-600 fs-18 drop-blue">
                            Add Stripe integration
                        </p>
                        <v-btn style="display: none;" ref="stripe_btn" :href="onboardLink" dense class="white--text small-btns ml-3" color="secondary">Link stripe account</v-btn>
                    </div>
                </v-col>
                <v-col cols="6" v-if="!is_error">

                </v-col>
                <v-col cols="12" v-if="is_error">
                    <v-alert type="error">{{$t('This section temporary unavailable.')}}</v-alert>
                </v-col>
            </v-row>
        </my-form>
        <div v-else style="width: 100%" class="mt-5">
            <v-layout row wrap>
                <div class="col-lg-12">
                    <div class="row">
                        <div class="col-lg-12 d-flex justify-end">
                            <secondary-button class="ml-10" :activeButton="true">Refresh</secondary-button>
                            <primary-button class="ml-5" :activeButton="true">Export CSV</primary-button>
                        </div>
                        <div class="col-md-12 mt-5">
                            <v-row wrap>
                                <div class="col-12">
                                    <v-card class="my-shadow pa-3">
                                        <div class="row pl-4 pt-3" style="border-bottom: 1px solid #E0E0E0;">
                                            <div class="col-md-12 d-flex align-center">
                                                <div class="row">
                                                    <div class="col-md-6 pb-0 d-flex justify-space-around">
                                                        <p class="ma-0 fs-16 fw-400">Show:</p>
                                                        <p class="ma-0 fs-16 hover" :class="[selectedTab == 'Payment Requested' ? 'product-tab-active' : 'product-tab-inactive']" @click="selectedTab = 'Payment Requested'">{{ 'Payment Requested' }}</p>
                                                        <p class="ma-0 fs-16 hover" :class="[selectedTab == 'Payment Not Requested' ? 'product-tab-active' : 'product-tab-inactive']" @click="selectedTab = 'Payment Not Requested'">{{ 'Payment Not Requested' }}</p>
                                                        <p class="ma-0 fs-16 hover" :class="[selectedTab == 'Custom Payment Request' ? 'product-tab-active' : 'product-tab-inactive']" @click="selectedTab = 'Custom Payment Request'">{{ 'Custom Payment Request' }}</p>
                                                    </div>
                                                    <div class="col-md-6 d-flex align-center justify-end">
                                                        <div class="mr-4 d-flex flex-row">
                                                            <p class="ma-0 fw-400 fs-18 d-flex align-center flex-row selectAmount">Show on site:
                                                                <v-select
                                                                    style="display: inline-block;width: 20px!important;"
                                                                    class="no-validation ml-2"
                                                                    :items="[5,10,15,25]"
                                                                    v-model="requestAmount"
                                                                    dense
                                                                    ref="users_amount"
                                                                ></v-select>
                                                                <v-img @click="$refs.users_amount.isMenuActive = true" class="hover" max-width="15px" max-height="15px" :src="$root.getSrc('/default/drop_icons/arrow_down.svg')" ></v-img>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <div class="row pl-4 pt-3 pb-3" style="border-bottom: 1px solid #E0E0E0;">
                                            <div class="col-md-12 d-flex align-center">
                                                <div class="row" v-if="selectedTab != 'Custom Payment Request'">
                                                    <div class="col-md-4 d-flex align-center">
                                                        <v-text-field v-model="term" class="no-validation" dense style="border-radius: 8px;" outlined append-icon="mdi-magnify" :class="[term.length == 0 ? 'product-name-filter' : '']" placeholder="What you are looking for?"></v-text-field>
                                                    </div>
                                                    <div class="col-md-8 d-flex align-center">
                                                        <p class="ma-0 fw-400 fs-18">Status:</p>
                                                        <v-btn class="small-btns ml-4" @click="selectedRequestFilter = 'all';" :class="[selectedRequestFilter != 'all' ? 'product-inactive-button' : '']" outlined :color="selectedRequestFilter != 'all' ? 'super_light_blue' : 'blue_drop'">All ({{all}})</v-btn>
                                                        <v-btn class="small-btns ml-2" @click="selectedRequestFilter = 'paid';" :class="[selectedRequestFilter != 'paid' ? 'product-inactive-button' : '']" outlined :color="selectedRequestFilter != 'paid' ? 'super_light_blue' : 'blue_drop'">Paid ({{paid}})</v-btn>
                                                        <v-btn class="small-btns ml-2" @click="selectedRequestFilter = 'not_paid';" :class="[selectedRequestFilter != 'not_paid' ? 'product-inactive-button' : '']" outlined :color="selectedRequestFilter != 'not_paid' ? 'super_light_blue' : 'blue_drop'">Request ({{request}})</v-btn>
                                                    </div>
                                                </div>
                                                <div class="row"  v-else>
                                                    <div class="col-md-12 d-flex align-center">
                                                        <p class="ma-0 fw-400 fs-18">I want to send request to:</p>
                                                        <v-btn class="small-btns ml-4" @click="selectedCustomRequest = 'client';" :class="[selectedCustomRequest != 'client' ? 'product-inactive-button' : '']" outlined :color="selectedCustomRequest != 'client' ? 'super_light_blue' : 'blue_drop'">Client</v-btn>
                                                        <v-btn class="small-btns ml-2" @click="selectedCustomRequest = 'store_owner';" :class="[selectedCustomRequest != 'store_owner' ? 'product-inactive-button' : '']" outlined :color="selectedCustomRequest != 'store_owner' ? 'super_light_blue' : 'blue_drop'">Store owner (user)</v-btn>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <div class="row pl-4 pr-4" v-if="requests && selectedTab != 'Custom Payment Request'">
                                            <div class="drop-checkbox  pt-5 w-100">
                                                <v-data-table
                                                    class="order-table"
                                                    :loading="load"
                                                    :items="selectedTab == 'Payment Requested' ? requests : finalRequestOrders"
                                                    :headers="selectedTab == 'Payment Requested' ? headers : headersNotRequested"
                                                    :hide-default-footer="true"
                                                    :footer-props="{'items-per-page-options': [5, 10, 15, 20]}"
                                                >
                                                    <template v-slot:item.id="{item}">
                                                        #{{item.id}}
                                                    </template>

                                                    <template v-slot:item.total="{item}">
                                                        {{item.total}} AUD
                                                    </template>

                                                    <template v-slot:item.amount_of_orders="{item}">
                                                        {{ item.amount_of_orders }}
                                                    </template>

                                                    <template v-slot:item.amount_to_request="{item}">
                                                        {{ item.amount_to_request }} AUD
                                                    </template>

                                                    <template v-slot:item.store="{item}">
                                                        {{ item.website ? item.website.name : (item.email ? item.email : 'Not Found')}}
                                                    </template>

                                                    <template v-slot:item.email="{item}">
                                                        {{item.user ? item.user.email : 'Not Found'}}
                                                    </template>

                                                    <template v-slot:item.created="{item}">
                                                        {{getDate(item.created_at)}}
                                                    </template>

                                                    <template v-slot:item.status="{item}">
                                                        <span class="drop-chip">
                                                            {{ item.is_paid ? 'paid' : 'request'}}
                                                        </span>
                                                    </template>

                                                    <template v-slot:item.actions="{item}">
                                                        <div class="d-flex justify-start flex-row">
                                                            <v-img v-if="selectedTab == 'Payment Requested'" @click="changeHrefTo(item)" class="hover" max-width="24px" max-height="24px" contain :src="$root.getSrc('/default/drop_icons/eye.svg')"></v-img>
                                                            <v-img v-else @click="createPayment(item)" class="hover" max-width="24px" max-height="24px" contain :src="$root.getSrc('/default/drop_icons/mail.svg')"></v-img>
                                                        </div>
                                                    </template>


                                                </v-data-table>
                                            </div>
                                        </div>

                                        <div class="row mt-5" v-else>
                                            <div class="col-md-2"></div>
                                            <div class="col-md-8">
                                                <v-text-field :disabled="selectedCustomRequest != 'client'" :rules="[validationRules.required]" v-model="address.name" dense height="48" color="blue_drop" class="no-validation mt-5"  style="border-radius: 8px;" outlined  label="Name (enter name and surname)"></v-text-field>
                                                <v-text-field :disabled="selectedCustomRequest != 'client'" :rules="[validationRules.required, validationRules.email]" v-model="address.email" dense height="48" color="blue_drop" class="no-validation mt-5"  style="border-radius: 8px;" outlined  label="Email address"></v-text-field>

                                                <v-combobox
                                                    v-if="selectedCustomRequest != 'client'"
                                                    @change="fillAddress()"
                                                    outlined
                                                    dense
                                                    v-model="chosen_user"
                                                    item-text="name"
                                                    item-value="id"
                                                    label="Choose user"
                                                    height="48"
                                                    color="blue_drop"
                                                    :items="usersSortedByName"
                                                    style="border-radius: 8px;"
                                                    class="no-validation mt-5"
                                                >
                                                    <template slot="item" slot-scope="data">
                                                        {{ data.item.name }} - {{ data.item.email }}
                                                    </template>
                                                </v-combobox>

                                                <v-text-field v-model="address.description" dense height="48" color="blue_drop" class="no-validation mt-5"  style="border-radius: 8px;" outlined  label="Description"></v-text-field>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <v-text-field v-model="address.amount" type="number" min="0" step="0.01" dense height="48" color="blue_drop" class="no-validation mt-5"  style="border-radius: 8px;" outlined  label="Amount"></v-text-field>
                                                    </div>
                                                </div>
                                                <div class="d-flex flex-row mt-5">
                                                    <primary-button :loading="loading" @clickBtn="sendRequest" :activeButton="true">Send request</primary-button>
                                                </div>
                                            </div>
                                            <div class="col-md-2"></div>

                                        </div>


                                        <div class="d-flex justify-end text-center mt-5" v-if="selectedTab != 'Custom Payment Request'">
                                            <v-pagination
                                                v-model="page"
                                                :length="7"
                                                :total-visible="5"
                                            ></v-pagination>
                                        </div>
                                    </v-card>
                                </div>
                            </v-row>
                        </div>
                    </div>
                </div>
            </v-layout>
        </div>
    </div>
    <div v-else class="w-100 mt-5">
        <div class="d-flex justify-space-between mb-5">
            <p class="ma-0 fs-36 fw-400">You need to create website first</p>
            <v-btn v-ripple="false"  to="/websites/create"  class="ml-2 white--text drop-button button-primary-active" color="#2F80ED">
                Create new website
            </v-btn>
        </div>

        <v-skeleton-loader
            v-bind="attrs"
            type="image, actions"
        ></v-skeleton-loader>
    </div>
</template>
<script>

import {getAdminOrders, getPaymentRequests} from "@/api/orders";
import {
    getStripeOnboardLink,
    resetStripeId, refreshStripe } from "@/api/websites";
const MerchantEditAdd = () => ({
    component: import('./braintree_merchant'),
    timeout: 3000
})
import {createPaymentRequest, sendCustomPaymentRequest} from "@/api/payment_request";
import {getAdminUsers} from "@/api/user";
import {deleteBread} from "@/api/bread";
export default {
    props:['website_id', 'second_paypal_account','copyPayPal'],
    data(){
        return{
            address: {},
            selectedTab: 'Payment Requested',
            page: 1,
            all: 0,
            paid: 0,
            request: 0,
            selectedRequestFilter: 'all',
            selectedCustomRequest: 'client',
            term: '',
            showMoreInformations: false,
            requestAmount: 5,
            payments:[],
            load: false,
            links:null,
            errors:{},
            is_error: false,
            sendLinkViaEmail: false,
            loading: false,
            emailPayPalLink: null,
            websitePayPal: null,
            onboardLink: null,
            requests: null,
            headers: [
                {
                    text: 'ID',
                    value: 'id',
                    sortable: false,
                    width: '70px',
                    align: 'left'
                },
                {
                    text: 'Store/User',
                    value: 'store',
                    sortable: false,
                    width: '140px',
                    align: 'left'
                },
                {
                    text: 'Created',
                    value: 'created',
                    sortable: false,
                    width: '70px',
                    align: 'left'
                },
                {
                    text: 'Total',
                    value: 'total',
                    sortable: false,
                    width: '70px',
                    align: 'left'
                },
                {
                    text: 'Status',
                    value: 'status',
                    sortable: false,
                    width: '70px',
                    align: 'left'
                },
                {
                    text: '',
                    value: 'actions',
                    width: '50px',
                    align: 'left'
                }
            ],
            headersNotRequested: [
                {
                    text: 'Store',
                    value: 'store',
                    sortable: false,
                    width: '140px',
                    align: 'left'
                },
                {
                    text: 'Amount of orders',
                    value: 'amount_of_orders',
                    sortable: false,
                    width: '70px',
                    align: 'left'
                },
                {
                    text: 'Amount to request',
                    value: 'amount_to_request',
                    sortable: false,
                    width: '70px',
                    align: 'left'
                },
                {
                    text: '',
                    value: 'actions',
                    width: '50px',
                    align: 'left'
                }
            ],
            finalRequestOrders: [],
            finalRequestOrdersSent: [],
            paidRequests: [],
            notPaidRequests: [],
            itemToSend: null,
            chosen_user: null,
            usersSortedByName: null,
            attrs: {
                class: 'mb-6',
                boilerplate: true,
                elevation: 2,
            },
        }
    },
    computed:{
        isValid(){
            return this.websites.length > 0 || this.$store.getters.user.website_role.name == 'admin';
        },
        isAdmin(){
            return this.$store.getters.user.website_role.name == 'admin';
        },
        activeWebsite(){
            if(!this.website_id){
                return this.$store.getters.activeWebsite
            }else{
                return this.$store.getters.websites.find(x => x.id == this.website_id);
            }
        },
        selectedWebsite(){
            if(!this.website_id){
                return this.$store.getters.activeWebsite
            }else{
                return this.$store.getters.websites.find(x => x.id == this.website_id);
            }
        },
        websites(){
            return this.$store.getters.websites;
        }
    },
    mounted(){
        if(!this.isAdmin){
            this.getPayments();
            if(this.$route.query.return_message && this.$route.query.return_message.length>0){
                this.$store.commit('app/ADD_MESSAGE', {text: this.$route.query.return_message, type:'info'});
            }
        } else {
            this.getPaymentRequests();
            this.getUsers();
        }

    },
    watch:{
        selectedRequestFilter(){
            this.getPaymentRequests();
        },
        term(){
            this.getPaymentRequests(false);
        }
    },
    methods:{
        refreshStripe(){
            this.load = true;
            let obj = {
                'type': this.second_paypal_account ? 'user' : 'website',
                'active_website': this.activeWebsite.id,
                'active_user': this.$store.getters.user.id
            }
            refreshStripe(obj).then(res=>{
                this.load = false;
                this.getPayments();
                this.$store.commit('app/ADD_MESSAGE', {text: "Stripe data successfully updated.", type:'success'});
            }).catch(e => {
                this.load = false;
                this.$store.commit('app/ADD_MESSAGE', {text: "Something went wrong...", type:'error'});
            })
        },
        getUsers(){
            getAdminUsers().then(res=>{
                this.usersSortedByName = res.data.sort(function(a, b){
                    if(a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                    if(a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                    return 0;
                })
            })
        },
        fillAddress(){
            if(this.chosen_user){
                console.log(this.chosen_user)

                this.usersSortedByName.forEach(person=>{
                    if(person.id == this.chosen_user.id){
                        this.address.email = this.chosen_user.email;
                        this.address.name = this.chosen_user.name;
                    }
                });

            }
        },
        sendRequest(){
            this.loading = true;
            let customRequest = {
                'email': this.address.email,
                'amount': this.address.amount,
                'description': this.address.description,
                'name': this.address.name,
            }
            sendCustomPaymentRequest(customRequest).then(res=>{
                this.getPaymentRequests(true);
                this.loading = false;
                this.selectedTab = 'Payment Requested';
                this.address = {};
                this.$store.commit('app/ADD_MESSAGE', {text: 'Payment request successfully sent!', type:'success'});
            }).catch(e => {
                this.loading = false;
                this.$store.commit('app/ADD_MESSAGE', {text: 'Something went wrong...', type:'error'});
            })
        },
        createPayment(item){
            if(!this.loading){
                this.itemToSend = item;
                this.$confirm('Payment request', 'Are you sure you want to send payment request?',{cancel: {text: 'Cancel', color:'error'}, accept: {text: 'Send payment request', color: 'primary'}}).then(res => {
                    this.loading = true;
                    createPaymentRequest(this.itemToSend.website_id).then(res=>{
                        this.getPaymentRequests(true);
                        this.loading = false;
                        this.$store.commit('app/ADD_MESSAGE', {text: this.$t('Request successfully sent'), type:'success'});
                    }).catch(e => {
                        this.loading = false;
                        this.$store.commit('app/ADD_MESSAGE', {text: 'Something went wrong with creating payment request. Try again later.', type: 'error'});
                    })
                })
            }
        },
        changeHrefTo(item){
            let websiteLink = item.website && item.website.link ? item.website : 'http://127.0.0.1:8001';
            console.log(websiteLink+'/payment/request/'+item.hash)
            location.href =  websiteLink+'/payment/request/'+item.hash;
        },
        getDate(date){
            var today = new Date(date);
            var dd = String(today.getDate()).padStart(2, '0');
            var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
            var yyyy = today.getFullYear();
            let minutes = today.getMinutes();
            if(minutes<10) minutes = '0'+minutes;
            return dd+'/'+mm+'/'+yyyy+' '+today.getHours()+':'+minutes;
        },
        goToHref(){
            location.href = this.onboardLink;
        },
        getOnboardLink(force=false){
            this.load = true;
            let obj = {
                'stripe_website_id': this.activeWebsite.id,
                'stripe_user': this.activeWebsite.user
            }
            if(!force) obj.stripe_account_id = this.activeWebsite.stripe_account_id;
            getStripeOnboardLink(obj).then(res=>{
                this.onboardLink = res.url;
                this.load = false;
            })
        },
        disconnect(){
            this.$confirm(this.$t('Disconnecting Stripe account'), this.$t('Are you sure, you want to disconnect Stripe account?')).then(res => {
                deleteBread('Payment', this.payments[0].id, {model_name: 'Shop/Payment'}).then(res => {
                    resetStripeId().then(res=>{
                        this.getPayments();
                        this.$store.commit('app/ADD_MESSAGE', {text: 'Disconnected successfully', type:'success'});
                    }).catch(e => {
                        this.$store.commit('app/ADD_MESSAGE', {text: 'Something went wrong, try again later', type:'error'});
                    });
                }).catch(e => {
                    this.$store.commit('app/ADD_MESSAGE', {text: 'Something went wrong, try again later', type:'error'});
                });
            })
        },
        getPayments(){
            this.load = true;
            if(this.selectedWebsite){
                this.$store.dispatch('websites/getPayments', this.selectedWebsite.id).then(res => {
                    this.payments = res.payments;
                    if(!this.payments.find(x => x.controller == 'stripe_merchant')){
                        this.getOnboardLink();
                    } else {
                        this.load = false;
                    }

                });
            } else {
                this.$store.commit('app/ADD_MESSAGE', {text: 'No active website.', type:'info'});
                this.load = false;
            }

        },
        save(){

        },
        getPaymentRequests(force = false){
            getAdminOrders({}).then(res=>{
                this.finalRequestOrders = [];
                this.finalRequestOrdersSent = [];
                let paidOrders = res.orders.data.filter(order => order.status === 'on_hold' && order.payment_request_sent == 0);
                let paidOrdersSent = res.orders.data.filter(order => order.status === 'on_hold' && order.payment_request_sent == 1);
                let paymentRequest = {}, paymentRequestSent = {};
                paidOrders.forEach(order=>{
                    if(!paymentRequest[order.website_id]){
                        paymentRequest[order.website_id] = [];
                    }
                    paymentRequest[order.website_id].push(order);
                })

                paidOrdersSent.forEach(order=>{
                    if(!paymentRequestSent[order.website_id]){
                        paymentRequestSent[order.website_id] = [];
                    }
                    paymentRequestSent[order.website_id].push(order);
                })


                for (const [key, orders] of Object.entries(paymentRequest)) {
                    let obj = {
                        'website_id': key,
                        'amount_of_orders': 0,
                        'amount_to_pay': 0,
                        'amount_paid': 0,
                        'amount_to_request':0,
                        'website': orders[0].website
                    };
                    orders.forEach(order=>{
                        obj.amount_of_orders+=1;
                        obj.amount_to_pay+=parseFloat(order.production_amount.toFixed(2));
                        obj.amount_paid+=parseFloat(order.amount);
                        obj.amount_to_request = parseFloat(obj.amount_to_pay) - parseFloat(obj.amount_paid);

                    })
                    obj.amount_to_pay = obj.amount_to_pay.toFixed(2);
                    obj.amount_paid = obj.amount_paid.toFixed(2);
                    obj.amount_to_request = obj.amount_to_request.toFixed(2);
                    this.finalRequestOrders.push(obj);
                }


                for (const [key, orders] of Object.entries(paymentRequestSent)) {
                    let obj = {
                        'website_id': key,
                        'amount_of_orders': 0,
                        'amount_to_pay': 0,
                        'amount_paid': 0,
                        'amount_to_request':0,
                        'website': orders[0].website
                    };
                    orders.forEach(order=>{
                        obj.amount_of_orders+=1;
                        obj.amount_to_pay+=parseFloat(order.production_amount);
                        obj.amount_paid+=parseFloat(order.amount);
                        obj.amount_to_request = parseFloat(obj.amount_to_pay) - parseFloat(obj.amount_paid);

                    })
                    obj.amount_to_pay = obj.amount_to_pay.toFixed(2);
                    obj.amount_paid = obj.amount_paid.toFixed(2);
                    obj.amount_to_request = obj.amount_to_request.toFixed(2);
                    this.finalRequestOrdersSent.push(obj);
                }
            })


            let obj = {
                term: this.term
            }

            if(this.selectedRequestFilter != 'all') obj.paid = this.selectedRequestFilter == 'paid' ? 1 : 0;
            getPaymentRequests(obj).then(res=>{
                this.requests = res;
                this.paidRequests = res.filter(request=> request.is_paid == 1);
                this.notPaidRequests = res.filter(request=> request.is_paid == 0);
                if(this.all == 0 || force){
                    this.all = this.paidRequests.length + this.notPaidRequests.length;
                    this.paid = this.paidRequests.length;
                    this.request = this.notPaidRequests.length;
                }
            })
        },
    }
}
</script>
